import styled from 'styled-components'

import { FemiTitle } from '../../styles'

export const StyledFemiReasons = {
  Title: styled(FemiTitle)`
    margin-bottom: 24px;
  `,
  Content: styled.div`
    padding-bottom: 88px;
  `,
}
